import { MediaType } from '@meitu/saas-editor-core/es/version-types';
import { editor } from '@/instance';

interface AddMediaParams {
    /** 素材ID */
    id: number | string;
    /** 素材URL */
    url: string;
    /** 素材信息 */
    info: {
        naturalWidth: number;
        naturalHeight: number;
        mediaType?: MediaType;
        autoplay?: boolean;
        loop?: boolean;
        controls?: boolean;
    };
    /** 是否显示加载状态 */
    showLoading?: boolean;
    /** 是否通过鼠标位置添加 */
    byMousePosition?: boolean;
}

export const useAddMediaLayer = () => {
    return {
        /**
         * 添加媒体素材
         */
        async add({ id, url, info, showLoading = true, byMousePosition = false }: AddMediaParams) {
            try {
                if (showLoading) {
                    editor.services.mask.show({
                        loading: true,
                        text: '加载中',
                    });
                }
                const defaultInfo = {
                    mediaType: MediaType.Image,
                    autoplay: true,
                    loop: true,
                    controls: true,
                };
                // 合并默认信息和传入的信息
                const mediaInfo = { ...defaultInfo, ...info };
                const result = await editor.mediaLayer.addMediaLayer(`${id}`, url, mediaInfo, byMousePosition);
                return result;
            } catch (e) {
                console.log(e);
                if (showLoading) editor.services.mask.hide();
            } finally {
                if (showLoading) editor.services.mask.hide();
            }
        },
    };
};
